import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, MuiPickersAdapterContext } from '@mui/x-date-pickers/LocalizationProvider';
export function PickerLocalization(param) {
    let { children } = param;
    const hostAdapter = useContext(MuiPickersAdapterContext);
    if ((hostAdapter === null || hostAdapter === void 0 ? void 0 : hostAdapter.utils) != null) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsx(LocalizationProvider, {
        dateAdapter: AdapterDateFns,
        children: children
    });
}
